<div class="screen-container">
	<p class="title-xs font-serra my-4">Cards Tool</p>
	<div class="tabs tabs-box mb-4">
		<a [routerLink]="router.get('admin-card-list')" routerLinkActive="tab-active" class="tab">Cartes</a>
		@if(userS.hasRight('indexes')){
			<a [routerLink]="router.get('admin-card-index')" routerLinkActive="tab-active" class="tab">Indexes</a>
		}
		@else{
			<span class="btn">Indexes</span>
		}
	</div>
	<router-outlet />
</div>